import { Group, Stack } from '@mantine/core';
import React, { ChangeEvent } from 'react';
import { OpenComponent } from '../../enums/misc.enum';
import { Roles } from '../../enums/roles-enum';
import { truncateString } from '../../helpers/common.helpers';
import useAuth from '../../hooks/useAuth';
import { BasicMerchant } from '../../type/entity.types';
import StatusText from '../admin-table/components/status-text.component';
import XSafeTextInfo from '../x-components/x-safe-text-info.component';
import XSkeletonLoadingTableBody from '../x-components/x-skeletons/x-skeleton-loading-table.component';
import XThead from '../x-components/x-table-header.component';
import XTable from '../x-components/x-table/x-table.component';

interface Props {
  merchantsData: BasicMerchant[] | undefined;
  setSelectedEntity: React.Dispatch<React.SetStateAction<number | undefined>>;
  setComponentManager: React.Dispatch<React.SetStateAction<OpenComponent>>;
  isChecked: number[];
  setIsChecked: React.Dispatch<React.SetStateAction<number[]>>;
  checkedAll: boolean;
  setCheckedAll: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading: boolean;
}
function MerchantsTable(props: Props) {
  const {
    merchantsData,
    setSelectedEntity,
    setComponentManager,
    isChecked,
    setIsChecked,
    checkedAll,
    setCheckedAll,
    isLoading,
  } = props;
  const { auth } = useAuth();
  const isViewOnly =
    auth?.role === Roles.SETTLEMENT || auth?.role === Roles.CHECKER;

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = e.target;
    if (checked) {
      setIsChecked([...isChecked, Number(id)]);
    } else {
      setIsChecked(isChecked.filter((item) => item !== Number(id)));
    }
  };

  const handleCheckAll = () => {
    if (!merchantsData) {
      return;
    }
    let arr = merchantsData;
    setCheckedAll(!checkedAll);

    if (checkedAll) {
      setIsChecked([]);
    } else {
      setIsChecked(arr.map((li) => li.merchantId));
    }
  };

  return (
    <>
      <XTable>
        <XThead>
          <tr>
            {!isViewOnly && (
              <th style={{ width: 30 }}>
                <input
                  type='checkbox'
                  style={{ cursor: 'pointer' }}
                  onChange={handleCheckAll}
                  checked={checkedAll}
                />
              </th>
            )}
            <th>Merchant name</th>
            <th>Primary contact number</th>
            <th>Location</th>
            <th>Association</th>
            <th>Status</th>
          </tr>
        </XThead>
        {isLoading ? (
          <XSkeletonLoadingTableBody numColumns={6} />
        ) : (
          <tbody>
            {merchantsData?.map((merchant) => (
              <tr key={merchant.merchantId}>
                {!isViewOnly && (
                  <td>
                    <input
                      type='checkbox'
                      style={{ cursor: 'pointer' }}
                      id={merchant.merchantId.toString()}
                      checked={isChecked.includes(merchant.merchantId)}
                      onChange={handleCheck}
                    />
                  </td>
                )}

                <td
                  onClick={() => {
                    setSelectedEntity(merchant.merchantId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <XSafeTextInfo
                    data={truncateString(merchant.merchantName, 20)}
                  />
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(merchant.merchantId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <XSafeTextInfo data={merchant.contact.phone.primary} />
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(merchant.merchantId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <XSafeTextInfo data={merchant.address.city} />
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(merchant.merchantId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <Stack spacing='xs'>
                    <Group>
                      <XSafeTextInfo data='Partner:' />
                      <XSafeTextInfo
                        data={merchant.association.partnerName}
                        weight={600}
                      />
                    </Group>
                    <Group>
                      <XSafeTextInfo data='Reseller:' />
                      <XSafeTextInfo
                        data={merchant.association.resellerName}
                        weight={600}
                      />
                    </Group>
                  </Stack>
                </td>
                <td
                  onClick={() => {
                    setSelectedEntity(merchant.merchantId);
                    setComponentManager(OpenComponent.VIEW_USER);
                  }}
                >
                  <StatusText
                    status={merchant.isActive ? 'ENABLED' : 'DISABLED'}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        )}
      </XTable>
    </>
  );
}

export default MerchantsTable;
